module.exports = __webpack_public_path__ + "static/media/correct.4b9f57df.svg";